import React, { useState, useEffect } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import LoginLogo from '../../Assets/images/Frame 39059 1.png';
import LoginImg from '../../Assets/images/Loginimage-woman-smile-happy-joy 1.png';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useLocation } from 'react-router-dom';
import apiClient from '../../Api/apiClient';
const NewPassword = () => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [passwordReTypeVisible, setPasswordReTypeVisible] = useState(false);
  const location = useLocation();
  const { phone, forgotFromAffiliator } = location.state || {};
  
  const [newUserName, setNewUserName] = useState('');
  const [newPassword, setNewPassword] = useState('');

  // Initialize state with values from localStorage
  const [password, setPassword] = useState('');
  const [ReTypepassword, setReTypepassword] = useState('');
  const [passwordStrength, setPasswordStrength] = useState({
    minLength: false,
    uppercase: false,
    lowercase: false,
    number: false,
    specialChar: false,
  });


  // console.log(phone);
  // Update localStorage whenever state changes
  useEffect(() => {
    localStorage.setItem('password', password);
  }, [password]);

  useEffect(() => {
    localStorage.setItem('reTypePassword', ReTypepassword);
  }, [ReTypepassword]);

  const handleLoginClick = () => navigate('/login');

  const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible);
  const toggleReTypePasswordVisibility = () =>
    setPasswordReTypeVisible(!passwordReTypeVisible);

  const validateForm = () => {
    const newErrors = {};
    if (!password) newErrors.password = 'Password is required';
    if (!ReTypepassword)
      newErrors.ReTypepassword = 'confirm Password is required';

    // Return the errors object
    return newErrors;
  };

  const handlePasswordChange = value => {
    setPassword(value);
    setPasswordStrength({
      minLength: value.length >= 8,
      uppercase: /[A-Z]/.test(value),
      lowercase: /[a-z]/.test(value),
      number: /\d/.test(value),
      specialChar: /[!@#$%^&*]/.test(value),
    });
  };

  // console.log(phone);
  const handleNewPassword = async () => {
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length === 0) {
      try {
        const signUpData = {
          phone,
          new_password: password,
          retype_new_password: ReTypepassword,
        };
  
        let url = '/auth/user/change-forget-password';
        if (forgotFromAffiliator) {
          url = '/auth/affiliator/change-forget-password';
        }
        const response = await apiClient.patch(url, signUpData, {
          withCredentials: true,
        });
  
        // Directly passing the response data to navigate
        Swal.fire({
          title: 'Success!',
          text: 'Success! Please Login!',
          customClass: {
            popup: 'w-72 h-auto p-3',
            title: 'text-lg',
            content: 'text-xs',
            confirmButton:
              'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
          },
        });
  
        if (forgotFromAffiliator) {
          navigate('/affiliator-login', {
            state: {
              user_name: response.data.username,
              pass_word: response.data.password,
            },
          });
        } else {
          navigate('/login', {
            state: {
              user_name: response.data.username,
              pass_word: response.data.password,
            },
          });
        }
  
      } 
      catch (error) {
           console.error('Error:', error);
           const errorMessage = error.response?.data?.message;
           Swal.fire({
             // icon: 'error',
             title: 'Error!',
             // text: 'Failed to send. Please try again.',
             text: errorMessage,
             customClass: {
               popup: 'w-72 h-auto p-3',
               title: 'text-lg',
               content: 'text-xs',
               confirmButton: 'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
             },
           });
         }
    } else {
      setErrors(validationErrors);
    }
  };

   // UseEffect to navigate after setting newUserName and newPassword
   useEffect(() => {
    if (newUserName && newPassword) {
      if (forgotFromAffiliator) {
        navigate('/affiliator-login', {
          state: {
            user_name: newUserName,
            pass_word: newPassword,
          },
        });
      } else {
        navigate('/login', {
          state: {
            user_name: newUserName,
            pass_word: newPassword,
          },
        });
      }
    }
  }, [newUserName, newPassword, forgotFromAffiliator, navigate]);


  const handleSignUpKey = e => {
    if (e.key === 'Enter') handleNewPassword();
  };

  return (
    <div className="flex bg-EntryBG items-center justify-center min-h-screen md:py-16 py-24 md:mt-10 mt-16 px-2 ">
      <div className="bg-white p-10 items-center justify-center flex flex-col lg:flex-row gap-10 shadow-xl rounded-xl">
        {/* left section */}
        <div>
          <img
            src={LoginLogo}
            alt="LoginLogo"
            className=" h-10 lg:h-16 mb-0 md:pl-8 lg:mb-0"
          />
          <img src={LoginImg} alt="LoginImg" className="md:h-40 h-32 " />
        </div>

        {/* right section */}
        <div>
          <h2 className="text-xl text-center lg:text-2xl font-semibold mt-1 mb-4 heading">
            Reset Password
          </h2>

          <div className="w-full lg:w-[400px] space-y-4 mt-2">
            {/* Input Fields */}
            <div className="flex flex-col space-y-4">
              <div className="relative w-full">
                <input
                  type={passwordVisible ? 'text' : 'password'}
                  placeholder="Password"
                  className="border border-gray-300 rounded-md py-2 px-4 w-full"
                  value={password}
                  onChange={e => handlePasswordChange(e.target.value)}
                  onKeyDown={handleSignUpKey}
                />
                <button
                  type="button"
                  onClick={togglePasswordVisibility}
                  className="absolute inset-y-0 right-0 flex items-center px-3 focus:outline-none"
                >
                  {passwordVisible ? <FaEyeSlash /> : <FaEye />}
                  <span className="ml-1 text-sm">
                    {passwordVisible ? 'Hide' : 'Show'}
                  </span>
                </button>
              </div>

              {/* Password Strength Checklist */}
              {password && (
                <div className="mt-2 text-xs text-gray-600 space-y-1">
                  <p
                    className={
                      passwordStrength.minLength
                        ? 'text-green-600'
                        : 'text-red-600'
                    }
                  >
                    {passwordStrength.minLength
                      ? '✔ Use at least 8 characters'
                      : '✘ Use at least 8 characters'}
                  </p>
                  <p
                    className={
                      passwordStrength.uppercase
                        ? 'text-green-600'
                        : 'text-red-600'
                    }
                  >
                    {passwordStrength.uppercase
                      ? '✔ Add at least one uppercase letter'
                      : '✘ Add at least one uppercase letter'}
                  </p>
                  <p
                    className={
                      passwordStrength.lowercase
                        ? 'text-green-600'
                        : 'text-red-600'
                    }
                  >
                    {passwordStrength.lowercase
                      ? '✔ Add at least one lowercase letter'
                      : '✘ Add at least one lowercase letter'}
                  </p>
                  <p
                    className={
                      passwordStrength.number
                        ? 'text-green-600'
                        : 'text-red-600'
                    }
                  >
                    {passwordStrength.number
                      ? '✔ Include at least one number'
                      : '✘ Include at least one number'}
                  </p>
                  <p
                    className={
                      passwordStrength.specialChar
                        ? 'text-green-600'
                        : 'text-red-600'
                    }
                  >
                    {passwordStrength.specialChar
                      ? '✔ Include at least one special character'
                      : '✘ Include at least one special character'}
                  </p>
                </div>
              )}

              {errors.password && (
                <p className="text-red-500 text-xs mb-0 -mt-2">
                  {errors.password}
                </p>
              )}

              <div className="relative w-full">
                <input
                  type={passwordReTypeVisible ? 'text' : 'password'}
                  placeholder="Confirm Password"
                  className="border border-gray-300 rounded-md py-2 px-4 w-full"
                  value={ReTypepassword}
                  onChange={e => setReTypepassword(e.target.value)}
                  onKeyDown={handleSignUpKey}
                />
                <button
                  type="button"
                  onClick={toggleReTypePasswordVisibility}
                  className="absolute inset-y-0 right-0 flex items-center px-3 focus:outline-none"
                >
                  {passwordReTypeVisible ? <FaEyeSlash /> : <FaEye />}
                  <span className="ml-1 text-sm">
                    {passwordReTypeVisible ? 'Hide' : 'Show'}
                  </span>
                </button>
              </div>
              {errors.ReTypepassword && (
                <p className="text-red-500 text-xs mb-0 -mt-2">
                  {errors.ReTypepassword}
                </p>
              )}
            </div>
            <button
              onClick={handleNewPassword}
              className="w-full bg-EntryBG text-white py-2 px-6 hover:bg-btnHover mb-2 mt-2 rounded-2xl"
            >
              Submit
            </button>

            {/* Already have an account? */}
            <p className="mb-0 text-center lg:text-sm text-xs text-gray-600">
              Already have an account?
              <button onClick={handleLoginClick} className="underline ml-2">
                Login
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewPassword;
